import { Observable } from 'rxjs';

export abstract class SeoConfig {
  seo?: SeoOptions;
}

export interface SeoOptions {
  structuredData?: StructuredData;
}

export interface StructuredData {
  disableInDevMode?: boolean;
}

export interface SchemaBuilder {
  build(): Observable<object>;
}
export interface JsonLdBuilder<T> {
  build(data: T): Observable<object>;
}

export interface SocialMediaJSONLDModel {
  name: string;
  url: string;
  iconType?: string;
}

export const socials: SocialMediaJSONLDModel[] = [
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/company/boels-rental',
    iconType: 'LINKEDIN',
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/Boels.Rental/',
    iconType: 'FACEBOOK_SQUARE',
  },
  {
    name: 'youtube',
    url: 'https://www.youtube.com/channel/UCj6vdOwgM6-6rOi_vEBv4bA',
    iconType: 'YOUTUBE',
  },
  {
    name: 'twitter',
    url: 'https://www.twitter.com/boelsrental',
    iconType: 'TWITTER',
  },
];
